<template>
  <div class="mx-3">
    <d-button
      :key="'theme-' + currentTheme"
      :title="themeLabel"
      @click.prevent.stop="toggleTheme"
      outline
      class="w-100">
      <i class="material-icons mr-1">{{ themeIcon }}</i>
      {{ themeLabel }}
    </d-button>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'theme-switcher',
  data () {
    return {
      currentTheme: localStorage.getItem('wedliny-crm-theme') || 'light',
      themes: ['light', 'dark']
    };
  },
  computed: {
    themeLabel () {
      if (this.currentTheme === 'dark') {
        return 'Ustaw jasny motyw';
      }

      return 'Ustaw ciemny motyw';
    },
    themeIcon () {
      if (this.currentTheme === 'dark') {
        return 'light_mode';
      }

      return 'dark_mode';
    },
  },
  methods: {
    toggleTheme () {
      this.$bus.$emit('app-toggle-theme');

      Vue.nextTick(() => {
        let storedValue = localStorage.getItem('wedliny-crm-theme');
        if (!storedValue || !this.themes.includes(storedValue)) {
          this.currentTheme = 'light';
        }
        this.currentTheme = storedValue;
      });
    }
  }
};
</script>
